import DefaultUser from '../assets/images/default-avatar.png';
import logo from '../assets/images/logo.svg';
import skateboardingImg from '../assets/images/skateboarding-img.png';

export const IMAGE_PATHS = {
  DefaultUser,
  logo,
  skateboardingImg
};
